import React, {useEffect, useRef, useState} from 'react';
import Icon from '../icon';
import {useDispatch} from 'react-redux';
import {flash as setFlash} from '../../../actions/sharingDetailsActions';
import './index.css';


/**
 * @return {string}
 */

function FlashMessage ({type, message}) {

	const dispatch = useDispatch();
	const flashRef = useRef(null);

	const [currentType, setCurrentType] = useState(type);
	const [currentMessage, setCurrentMessage] = useState(message);

	useEffect(() => {
		const flashEl = flashRef.current;

		if (!flashEl) return;

		//console.log('➖ Remove class');
		flashEl.classList.remove('animation-end');

		//console.log('⏳ Force reflow');
		void flashEl.offsetHeight;

		//console.log('➕ Add class');
		setTimeout(() => {
			setCurrentType(type);
			setCurrentMessage(message);
			flashEl.classList.add('animation-end');
		}, 500);

	}, [type, message]);

	const handleClose = () => {

		const flashEl = flashRef.current;

		if (flashEl) {
			flashEl.classList.remove('animation-end');
		}

		setTimeout(() => {
			dispatch(setFlash(null))
		}, 500);
	};

	return (
		<div ref={flashRef} className={currentType ? `flash alert alert-${currentType}` : 'flash alert'} role="alert">
			{currentType === "danger" ? <Icon name="times-circle" className="mr-2"/> : <Icon name="check" className="mr-2"/>}
			<span dangerouslySetInnerHTML={{__html: currentMessage}}/>
			<button type="button" className="close ml-2" data-dismiss="alert" aria-label="Close" onClick={ handleClose }>
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	)

}

export default FlashMessage;
